<script>
import { Carousel, Slide } from "vue-carousel";
import { cloneDeep } from "lodash";

export default {
  name: "PropertyLocationModal",
  props: {
    altId: {
      type: String,
      default: "location-modal",
    },
  },
  components: {
    Carousel,
    Slide,
  },
  data() {
    return {
      tableData: [],
      modalTitle: "",
      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, 100],
      filter: "",
      filterLocation: "",
      sortDesc: false,
      fields: [
        {
          key: "buildingName",
          sortable: true,
        },
        {
          key: "buildingLocation",
          thStyle: { width: "200px" },
          sortable: true,
        },
        {
          key: "buildingDescription",
          thStyle: { width: "200px" },
          sortable: true,
        },
      ],
      fieldsLocation: [
        {
          key: "location",
          sortable: true,
        },
        {
          key: "locationCode",
          thStyle: { width: "200px" },
          sortable: true,
        },
        {
          key: "floorNumber",
          thStyle: { width: "130px" },
        },
        {
          key: "roomNumber",
          thStyle: { width: "130px" },
        },
      ],
      locations: null,
      form: {
        id: 0,
        buildingName: "",
        buildingLocation: "",
        buildingDescription: "",
        campusId: null,
      },
      formLocation: {
        id: 0,
        location: "",
        locationCode: "",
        floorNumber: null,
        roomNumber: null,
        buildingId: null,
      },
      tabIndex: 0,
      campus: "",
      campusSelected: this.$store.state.data.selectedCampus.id,
      campusOptions: this.$store.state.decrypt.campusAccessList(),
      tableBusy: false,
    };
  },
  computed: {
    filtered() {
      let data = this.tableData;
      if (this.filter.trim() != "" && this.filter) {
        data = data.filter((item) => {
          if (
            item.buildingName.toUpperCase().includes(this.filter.toUpperCase())
          ) {
            return item.buildingName
              .toUpperCase()
              .includes(this.filter.toUpperCase());
          } else if (
            item.buildingLocation
              .toUpperCase()
              .includes(this.filter.toUpperCase())
          ) {
            return item.buildingLocation
              .toUpperCase()
              .includes(this.filter.toUpperCase());
          } else if (
            item.buildingDescription
              .toUpperCase()
              .includes(this.filter.toUpperCase())
          ) {
            return item.buildingDescription
              .toUpperCase()
              .includes(this.filter.toUpperCase());
          }
        });
      }
      return data;
    },
    rows() {
      if (this.filter.trim() != "" && this.filter) {
        return this.filtered.length;
      } else {
        return this.tableData.length;
      }
    },
    filteredLocation() {
      let data = this.locations.locations;
      if (this.filterLocation.trim() != "" && this.filterLocation) {
        data = data.filter((item) => {
          if (
            item.location
              .toUpperCase()
              .includes(this.filterLocation.toUpperCase())
          ) {
            return item.location
              .toUpperCase()
              .includes(this.filterLocation.toUpperCase());
          } else if (
            item.locationCode
              .toUpperCase()
              .includes(this.filterLocation.toUpperCase())
          ) {
            return item.locationCode
              .toUpperCase()
              .includes(this.filterLocation.toUpperCase());
          }
        });
      }
      return data;
    },
    rowsLocation() {
      if (this.filterLocation.trim() != "" && this.filterLocation) {
        return this.filteredLocation.length;
      } else {
        return this.locations.locations.length;
      }
    },
  },
  methods: {
    getData(campusId) {
      this.tabIndex = 0;
      this.currentPage = 1;
      this.tableBusy = true;
      this.campusSelected = campusId;
      this.$store
        .dispatch("propertylocation/GetBuilding", campusId)
        .then((res) => {
          this.tableBusy = false;
          if (res.data.error) {
            return this.showToast(res.data.errorMessage, "error");
          }
          res.data.forEach((item) => {
            item.currentPage = 1;
            item.perPage = 10;
            item.tableBusy = false;
            item.locations = null;
          });
          this.tableData = res.data;
        })
        .catch(() => {
          this.tableBusy = false;
          return this.showToast(
            "Something went wrong - getting location list!",
            "error"
          );
        });
    },
    getLocation() {
      this.locations.tableBusy = true;
      this.locations.currentPage = 1;
      this.locations.perPage = 10;
      this.filterLocation = "";
      this.locations.locations = [];
      this.$store
        .dispatch("propertylocation/GetPropertyLocation", this.locations.id)
        .then((res) => {
          if (res.data.error) {
            return this.showToast(res.data.errorMessage, "error");
          }
          this.locations.locations = res.data;
          this.locations.tableBusy = false;
        })
        .catch(() => {
          this.locations.tableBusy = false;
          return this.showToast(
            "Something went wrong - getting location list!",
            "error"
          );
        });
    },
    viewLocations(data) {
      this.locations = cloneDeep(data[0]);
      this.getLocation();
      this.tabIndex = 1;
      this.$refs.carousel.goToPage(this.$refs.carousel.getNextPage());
    },
    returnToTable() {
      this.tabIndex = 0;
      this.locations = null;
      this.$refs.carousel.goToPage(this.$refs.carousel.getPreviousPage());
    },
    dropData(data) {
      var location = data[0];
      this.$emit("dropData", { location });
      this.returnToTable();
      this.$bvModal.hide(this.altId);
    },
  },
};
</script>

<template>
  <b-modal
    :id="altId"
    title="Location List"
    size="xl"
    title-class="font-18"
    hide-footer
  >
    <carousel
      ref="carousel"
      class="events navs-carousel"
      id="timeline-carousel"
      :navigation-enabled="false"
      :pagination-enabled="false"
      :perPage="1"
      :autoplay="false"
      :minSwipeDistance="0"
      :mouseDrag="false"
    >
      <slide class="p-0">
        <div v-if="tabIndex == 0">
          <div class="row mb-2 mt-1">
            <div class="col-3">
              <div class="d-flex align-items-center h-100">
                <h5 class="mb-0">Building List</h5>
              </div>
            </div>
            <div class="col-9">
              <label class="d-flex align-items-center">
                <b-form-select
                  id="campusSelect"
                  class="form-select"
                  v-model="campusSelected"
                  size="sm"
                  @change="getData(campusSelected)"
                >
                  <option v-for="x in campusOptions" :key="x.Id" :value="x.Id">
                    {{ x.CampusName }}
                  </option>
                </b-form-select>
                <b-form-input
                  autocomplete="off"
                  v-model="filter"
                  type="search"
                  placeholder="Search building..."
                  class="form-control mx-2 w-75"
                ></b-form-input>
                <b-form-select
                  class="form-select w-25"
                  v-model="perPage"
                  :options="pageOptions"
                ></b-form-select>
              </label>
            </div>
          </div>
          <div class="table-responsive mb-0">
            <b-table
              class="datatables"
              :items="filtered"
              :fields="fields"
              responsive="sm"
              :per-page="perPage"
              :current-page="currentPage"
              sort-by="buildingLocation"
              :sort-desc.sync="sortDesc"
              :busy="tableBusy"
              bordered
              outlined
              striped
              hover
              show-empty
              select-mode="single"
              selectable
              @row-selected="viewLocations"
              selected-variant="success"
            >
              <template #empty>
                <div class="text-center">
                  <div>
                    <i class="fas fa-exclamation-triangle me-2"></i>No Data
                    Found
                  </div>
                </div>
              </template>
              <template #table-busy>
                <div class="d-flex justify-content-center align-items-center">
                  <div class="preloader-component me-2">
                    <div class="status">
                      <div class="spinner-chase w-20px h-20px">
                        <div class="chase-dot"></div>
                        <div class="chase-dot"></div>
                        <div class="chase-dot"></div>
                        <div class="chase-dot"></div>
                        <div class="chase-dot"></div>
                        <div class="chase-dot"></div>
                      </div>
                    </div>
                  </div>
                  <strong>Loading...</strong>
                </div>
              </template>
            </b-table>
          </div>
          <div class="row">
            <div class="col">
              <div class="dataTables_paginate paging_simple_numbers float-end">
                <ul class="pagination pagination-rounded mb-0">
                  <!-- pagination -->
                  <b-pagination
                    v-model="currentPage"
                    :total-rows="rows"
                    :per-page="perPage"
                  ></b-pagination>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </slide>
      <slide class="p-0">
        <div v-if="tabIndex == 1 && locations">
          <div class="row mt-1 mb-3">
            <div class="col-sm-12 col-md-6">
              <div class="d-flex align-items-center h-100">
                <a
                  href="javascript:void(0);"
                  class="d-flex align-items-center"
                  @click="returnToTable()"
                  ><i class="bx bx-left-arrow-alt fs-2 me-1"></i>
                  <h5 class="m-0">Location List</h5></a
                >
              </div>
            </div>
            <div class="col-sm-12 col-md-6">
              <label class="d-flex align-items-center">
                <b-form-input
                  autocomplete="off"
                  v-model="filterLocation"
                  type="search"
                  placeholder="Search location..."
                  class="form-control mx-2 w-75"
                ></b-form-input>
                <b-form-select
                  class="form-select w-25"
                  v-model="locations.perPage"
                  :options="pageOptions"
                ></b-form-select>
              </label>
            </div>
          </div>
          <div class="table-responsive mb-0">
            <b-table
              class="datatables"
              :items="filteredLocation"
              :fields="fieldsLocation"
              responsive="sm"
              :per-page="locations.perPage"
              :current-page="locations.currentPage"
              sort-by="id"
              :sort-desc.sync="sortDesc"
              :busy="locations.tableBusy"
              bordered
              outlined
              striped
              hover
              show-empty
              select-mode="single"
              selectable
              @row-selected="dropData"
              selected-variant="success"
            >
              <template #empty>
                <div class="text-center">
                  <div>
                    <i class="fas fa-exclamation-triangle me-2"></i>No Data
                    Found
                  </div>
                </div>
              </template>
              <template #table-busy>
                <div class="d-flex justify-content-center align-items-center">
                  <div class="preloader-component me-2">
                    <div class="status">
                      <div class="spinner-chase w-20px h-20px">
                        <div class="chase-dot"></div>
                        <div class="chase-dot"></div>
                        <div class="chase-dot"></div>
                        <div class="chase-dot"></div>
                        <div class="chase-dot"></div>
                        <div class="chase-dot"></div>
                      </div>
                    </div>
                  </div>
                  <strong>Loading...</strong>
                </div>
              </template>
            </b-table>
          </div>
          <div class="row">
            <div class="col">
              <div class="dataTables_paginate paging_simple_numbers float-end">
                <ul class="pagination pagination-rounded mb-0">
                  <b-pagination
                    v-model="locations.currentPage"
                    :total-rows="rowsLocation"
                    :per-page="locations.perPage"
                  ></b-pagination>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </slide>
    </carousel>
  </b-modal>
</template>